// extracted by mini-css-extract-plugin
export default {"endpointCardList":"EndpointCardList_endpointCardList__7pqDA","endpointCard":"EndpointCardList_endpointCard__ckdQj"};